module.exports = "/wwwroot/img/climate_action_search_page.png?ver=ce806d92";